import React, { useEffect } from 'react';
import {
  Container,
  Sponsor,
  Apoio,
  Apoio3,
  SponsorGrid,
  ApoioGrid,
} from './styles';

const correalizacao = [
  {
    image: '/assets/evento/startse.svg',
    url: ['https://www.startse.com/'],
  },
];

const apoios2 = [
  {
    image: '/assets/evento/jar.png',
    url: ['https://online.ajars.org.br/'],
  },
];

const apoios3 = [
  {
    image: '/assets/evento/ciee.png',
    url: ['https://www.cieers.org.br/'],
  },
  {
    image: '/assets/evento/senac.png',
    url: ['https://www.senacrs.com.br/'],
  },
  {
    image: '/assets/evento/jar.png',
    url: ['https://online.ajars.org.br/'],
  },
  {
    image: '/assets/evento/rs.jpg',
    url: ['https://educacao.rs.gov.br/inicial'],
  },
  {
    image: '/assets/evento/unisinos.png',
    url: ['http://www.unisinos.br'],
  },
  {
    image: '/assets/evento/parceiros_branco.png',
    url: ['https://www.parceirosvoluntarios.org.br/'],
  },
];

const apoios4 = [
  {
    image: '/assets/evento/semana.png',
    url: ['https://www.empreendedorismo.org.br/#/'],
  },
];

const ouros = [
  {
    image: '/assets/evento/educacao.svg',
    url: ['https://educacaoempreendedora.sebraers.com.br/'],
  },
  {
    image: '/assets/evento/sebrae_branco.png',
    url: ['http://sebraers.com.br/'],
  },
];

const pratas = [
  {
    image: '/assets/evento/patrocinadores/encontrodigital.png',
    url: 'https://encontrodigital.com.br',
    url2: '',
  },
];

export const sponsors = [];

const FooterLayout: React.FC = ({ children }) => {
  return (
    <Container>
      <div style={{ maxWidth: '800px' }}>
        {' '}
        <h2>Parceiros</h2>
        <ApoioGrid>
          {apoios3.map(apoio => (
            <Apoio key={apoio.image}>
              <img src={apoio.image} />
              {apoio.url && apoio.url.map(ap => <a href={ap} title={ap} />)}
            </Apoio>
          ))}
        </ApoioGrid>
      </div>
      <div>
        <h2>Correalização</h2>
        <ApoioGrid>
          {correalizacao.map(apoio => (
            <Apoio key={apoio.image}>
              <img src={apoio.image} />
              {apoio.url && apoio.url.map(ap => <a href={ap} title={ap} />)}
            </Apoio>
          ))}
        </ApoioGrid>
      </div>

      <div>
        <h2>Realização</h2>
        <ApoioGrid>
          {ouros.map(apoio => (
            <Apoio key={apoio.image}>
              <img src={apoio.image} />
              {apoio.url && apoio.url.map(ap => <a href={ap} title={ap} />)}
            </Apoio>
          ))}
        </ApoioGrid>
      </div>
      <div style={{ width: '100%' }}>
        {' '}
        <h2 style={{ width: '100%', maxWidth: '350px', margin: '0 auto' }}>
          Um evento que faz parte da Semana Global do Empreendedorismo
{' '}
        </h2>
        <ApoioGrid>
          {apoios4.map(apoio => (
            <Apoio key={apoio.image}>
              <img src={apoio.image} />
              {apoio.url && apoio.url.map(ap => <a href={ap} title={ap} />)}
            </Apoio>
          ))}
        </ApoioGrid>
      </div>
    </Container>
  );
};

export const Realizacao: React.FC = ({ children }) => {
  return (
    <Container style={{ background: 'none' }}>
      <div>
        <ApoioGrid>
          {ouros.map(apoio => (
            <Apoio key={apoio.image}>
              <img src={apoio.image} />
              {apoio.url && apoio.url.map(ap => <a href={ap} title={ap} />)}
            </Apoio>
          ))}
        </ApoioGrid>
      </div>
    </Container>
  );
};

export default FooterLayout;
